import React, { useEffect } from 'react'
import { Bug } from '@yy/one-icon'
import MenuDialog from './components/MenuDialog/index'
import RecordTool from './components/RecordTool'
import Container from './Context'
import { useTranslation } from './hooks'
import styles from './index.module.less'
import type { IFeedbackProps } from './type'

export * from './utils/sentry'

const Feedback: React.FC<Omit<IFeedbackProps, 'enable'>> = (props) => {
  const { setLang, visible, setVisible, feedbackVisible, recordToolVisible, config, reset, lang } = Container.useContainer()
  const { t } = useTranslation()

  // 初始化 config
  useEffect(() => {
    config.current = {
      countryCode: props?.countryCode,
      email: props?.email,
      uid: props?.uid,
      appId: props?.appId,
      username: props?.username,
      sellerId: props?.sellerId,
    }
  }, [config, props?.countryCode, props?.email, props?.uid, props?.appId, props?.username, props?.sellerId])

  useEffect(() => {
    setLang(props.lang)
  }, [props.lang, setLang])

  const isChinese = ['zh-CN', 'zh-TW'].includes(lang)

  return (
    <>
      <MenuDialog visible={visible} onCancel={reset} />
      {recordToolVisible && <RecordTool />}

      {feedbackVisible && (
        <>
          <div className={isChinese ? styles.chineseFeedback : styles.feedback} onClick={() => setVisible(true)}>
            {t('feedback.title')}
          </div>

          <div className={styles['feedback-icon']} onClick={() => setVisible(true)}>
            <Bug />
          </div>
        </>
      )}
    </>
  )
}

const Component: React.FC<IFeedbackProps> = ({ enable, ...props }) => {
  if (!enable) return <></>

  return (
    <Container.Provider>
      <Feedback {...props} />
    </Container.Provider>
  )
}

Component.displayName = 'Feedback'
export default Component
